import React from 'react';

const CASE_TYPES = [
  { value: 'school', label: 'School Incident' },
  { value: 'workplace', label: 'Workplace Complaint' },
  { value: 'legal', label: 'Legal Dispute' },
  { value: 'medical', label: 'Medical Billing' },
  { value: 'insurance', label: 'Insurance Claim' },
  { value: 'hoa', label: 'HOA Conflict' },
  { value: 'other', label: 'Other' },
];

export const CreateCaseModal = ({ newCase, setNewCase, createCase, creating, onClose }) => (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4" onClick={onClose}>
    <div className="bg-white rounded-lg w-full max-w-lg p-6 border border-[#E5E7EB]" onClick={e => e.stopPropagation()} data-testid="create-case-modal">
      <h2 className="font-outfit text-2xl font-bold text-[#09090B] mb-6">New Investigation Case</h2>
      <form onSubmit={createCase} className="space-y-5">
        <div>
          <label className="block text-xs font-bold tracking-[0.2em] uppercase text-[#6B7280] mb-2 font-ibm">Case Title</label>
          <input data-testid="case-title-input" type="text" value={newCase.title} onChange={e => setNewCase({...newCase, title: e.target.value})} required
            className="w-full px-4 py-3 border border-[#E5E7EB] rounded-md bg-white text-[#09090B] font-ibm focus:outline-none focus:ring-2 focus:ring-[#002FA7]" placeholder="e.g., School District Investigation" />
        </div>
        <div>
          <label className="block text-xs font-bold tracking-[0.2em] uppercase text-[#6B7280] mb-2 font-ibm">Case Type</label>
          <select data-testid="case-type-select" value={newCase.case_type} onChange={e => setNewCase({...newCase, case_type: e.target.value})}
            className="w-full px-4 py-3 border border-[#E5E7EB] rounded-md bg-white text-[#09090B] font-ibm focus:outline-none focus:ring-2 focus:ring-[#002FA7]">
            {CASE_TYPES.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
          </select>
        </div>
        <div>
          <label className="block text-xs font-bold tracking-[0.2em] uppercase text-[#6B7280] mb-2 font-ibm">Description (Optional)</label>
          <textarea data-testid="case-description-input" value={newCase.description} onChange={e => setNewCase({...newCase, description: e.target.value})} rows={3}
            className="w-full px-4 py-3 border border-[#E5E7EB] rounded-md bg-white text-[#09090B] font-ibm focus:outline-none focus:ring-2 focus:ring-[#002FA7] resize-none" placeholder="Brief description..." />
        </div>
        <div className="flex gap-3 justify-end pt-2">
          <button type="button" onClick={onClose} className="px-5 py-2.5 border border-[#E5E7EB] text-[#09090B] font-ibm rounded-md hover:bg-[#F3F4F6] transition-all">Cancel</button>
          <button data-testid="create-case-submit" type="submit" disabled={creating}
            className="px-5 py-2.5 bg-[#002FA7] text-white font-ibm font-semibold rounded-md hover:bg-[#00237D] active:scale-[0.98] transition-all disabled:opacity-50">
            {creating ? 'Creating...' : 'Create Case'}
          </button>
        </div>
      </form>
    </div>
  </div>
);
